import React from "react";
import format from "date-fns/format";

import { getMoreFromThisData } from "core/MoreFromThis/helpers";
import { ICON_DETAIL_PAGE } from "data/links";

import TruncateText from "core/TruncateText";

const Heading = ({ text }) => (
    <>
        From: <TruncateText charLimit={20}>{text}</TruncateText>
    </>
);

export const getMoreFromThisIconCollection = ({ moreLikeThisIcon }) => {
    if (!moreLikeThisIcon || moreLikeThisIcon.items.length < 3) {
        return {
            items: null,
            heading: "",
            viewAll: ""
        };
    }

    return {
        items: getMoreFromThisData({
            items: moreLikeThisIcon.items,
            detailUrlPath: ICON_DETAIL_PAGE,
            detailUrlPathReplace: ":slugWithId",
            type: "icons"
        }),
        heading: <Heading text={moreLikeThisIcon.title} />,
        viewAll: moreLikeThisIcon.url
    };
};

export const getFormattedDate = ({ iconDetail }) => {
    const hasCreatedAt = iconDetail && iconDetail.createdAt !== null;

    const createdAtRegex = /-/gi; // replace - (dash) with , (comma)

    let newCreatedAt = "";

    let formattedCreatedAt = "";

    if (hasCreatedAt) {
        // take createdAt format of 1984-10-31 and reformat to 1984, 10, 31 so format() correctly returns date; without this, it will remove a day from the actual date:
        newCreatedAt = iconDetail.createdAt.replace(createdAtRegex, ",");

        // return new formatted date for frontend:
        formattedCreatedAt = format(new Date(newCreatedAt), "MMMM DD, YYYY");
    }

    return formattedCreatedAt;
};
